export default __webpack_public_path__ + "static/media/c1.2d462539.png";